import React from "react";

const MyWishlist = () => {
  return <div></div>;
};

export default MyWishlist;
